<div class="no-access-container">
  <div class="no-access-header">
    <fa-icon [icon]="banIcon"></fa-icon>
    <h1 class="no-access-title">Access denied</h1>
  </div>
  <p class="no-access-message">Please contact your administrator to request access permissions for this page.</p>
  @if (hasHomeAccess()) {
  <button type="button" class="btn btn-primary" (click)="redirectToHome()">Go to Home</button>
  }
</div>
